import { Breadcrumb, Button, Card, Col, Icon, Input, List, message, Popconfirm, Row, Select, Upload } from 'antd';
import { OptionProps } from 'antd/lib/select';
import { UploadFile } from 'antd/lib/upload/interface';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import * as xlsx from 'xlsx';

import { REDEEM_CODE_TEMPLATES_QUERY } from './RedeemCodeTemplateList';

const ReviewList = styled.div`
  margin-top: 30px;
`;

const SEND_REDEEM_CODES = gql`
  mutation sendRedeemCodes($courseName: String!, $mobiles: [String]!, $templateId: Int!) {
    sendRedeemCodes(courseName: $courseName, mobiles: $mobiles, templateId: $templateId)
  }
`;

interface Props {}
interface State {
  courseName: string;
  mobiles: string[];
  templateId?: number;
  fileList?: UploadFile[];
}

export class RedeemCodeSend extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { courseName: '', mobiles: [] };

    this.onTemplateIdChange = this.onTemplateIdChange.bind(this);
    this.courseNameChange = this.courseNameChange.bind(this);
  }

  onTemplateIdChange(id: number) {
    this.setState({ templateId: Number(id) });
  }

  courseNameChange(e: { target: { value: string } }) {
    this.setState({ courseName: e.target.value });
  }

  importList = () => {
    const { mobiles, courseName, templateId } = this.state;
    const props = {
      beforeUpload: (file: UploadFile | Blob) => {
        const oneFile = file as UploadFile;
        if (oneFile.status !== 'removed') {
          const fileList = [oneFile];
          this.setState({ fileList });
          const reader = new FileReader();
          const blob = file as Blob;
          reader.readAsBinaryString(blob);
          reader.onload = (event: any) => {
            const data = event.target.result;
            const workbook = xlsx.read(data, {
              type: 'binary',
            });

            const sheetName = workbook.SheetNames[workbook.SheetNames.length - 1];
            if (!sheetName) {
              return;
            }

            const mobileObjList: { mobile: string }[] = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName]) || [];

            const mobileList = mobileObjList.reduce((accumulator, currentValue) => {
              const { mobile } = currentValue;
              if (/^\d{11}$/g.test(mobile)) {
                accumulator.push(currentValue.mobile);
              }

              return accumulator;
            }, [] as string[]);

            this.setState({ mobiles: mobileList });
          };
        }
        return false;
      },
      onRemove: () => {
        this.setState({ fileList: [], mobiles: [] });
      },
    };

    return (
      <Mutation mutation={SEND_REDEEM_CODES} variables={{ mobiles, courseName, templateId }}>
        {sendRedeemCodes => {
          return (
            <>
              <Row gutter={16}>
                <Col span={6}>
                  <Query query={REDEEM_CODE_TEMPLATES_QUERY}>
                    {({ loading, error, data }) => {
                      if (error) return <div>{error.message}</div>;
                      if (loading) return <div>loading...</div>;
                      if (!data) {
                        // @ts-ignore
                        // eslint-disable-next-line react/jsx-no-undef
                        return <Empty />;
                      }
                      const redeemCodeTemplates = data.redeemCodeTemplates;
                      return (
                        <Select
                          style={{ width: '80%' }}
                          placeholder="template"
                          showSearch
                          onChange={this.onTemplateIdChange}
                          filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
                            return String(option.props.children).indexOf(input) >= 0;
                          }}
                        >
                          {redeemCodeTemplates.map((template: { id: string; channel: string; desc: string }) => (
                            <Select.Option key={template.id} value={template.id}>
                              {template.channel}-{template.desc}
                            </Select.Option>
                          ))}
                        </Select>
                      );
                    }}
                  </Query>
                </Col>
                <Col span={6}>
                  <Input type="text" placeholder="课程名称" allowClear onChange={this.courseNameChange} />
                </Col>
                <Col span={6}>
                  <Upload {...props} accept=".xls, .xlsx" fileList={this.state.fileList} multiple={false}>
                    <Button>
                      <Icon type="upload" /> 选择文件
                    </Button>
                  </Upload>
                </Col>
                <Col span={6}>
                  <Popconfirm
                    title={`总共${this.state.mobiles.length}条，确认发送吗？`}
                    onConfirm={async () => {
                      if (this.state.mobiles.length === 0) {
                        message.warning('请选择文件！');
                        return;
                      }
                      if (!this.state.courseName) {
                        message.warning('请填写课程名！');
                        return;
                      }
                      if (!this.state.templateId) {
                        message.warning('请选择兑换码模版！');
                        return;
                      }
                      try {
                        await sendRedeemCodes();
                        message.success('发送成功！');
                      } catch (error) {
                        message.error(error.message);
                      }
                    }}
                    okText="确认"
                    cancelText="取消"
                  >
                    <a href="#">
                      <Button type="primary">
                        发送 <Icon type="check" />
                      </Button>
                    </a>
                  </Popconfirm>
                </Col>
              </Row>
            </>
          );
        }}
      </Mutation>
    );
  };

  render() {
    return (
      <div>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>兑换码发送</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <div>{this.importList()}</div>
          <ReviewList>
            <List
              header={<div>发送列表</div>}
              bordered
              dataSource={this.state.mobiles}
              renderItem={item => <List.Item>{item}</List.Item>}
            />
          </ReviewList>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/redeemCode/RedeemCodeSend.tsx